<template>
  <div class="home">
    <!-- 顶部英雄区域 -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-left">
          <h1 class="company-name">华视集团</h1>
          <p class="company-subtitle">中国AI数字人应用第一股</p>
          <button class="watch-video-btn" @click="watchVideo">观看视频→</button>
        </div>
        <div class="hero-right">
            <img src="@/assets/image/home1.png" alt="华中融媒体生态家园" />
        </div>
      </div>
    </div>

    <!-- 视频弹框 -->
    <el-dialog
      :visible.sync="videoDialogVisible"
      width="70%"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      custom-class="video-dialog"
      @close="handleVideoClose"
      @opened="handleVideoOpened"
    >
      <div class="video-container">
        <video
          ref="videoPlayer"
          src="@/assets/video/home.mp4"
          controls
          autoplay
          muted
          style="width: 100%; height: auto;"
        >
          您的浏览器不支持视频播放。
        </video>
      </div>
    </el-dialog>
    
    <!-- 中间标题区域 -->
    <div class="main-headline">
      <h2>三大主营业务，助力企业降本增效</h2>
    </div>
    
    <!-- 底部产品展示区域 -->
    <div class="products-section">
      <div class="products-container">
        <!-- 左侧导航栏 -->
        <div class="sidebar">
          <div class="sidebar-item active">
            <div class="sidebar-icon">
              <img src="@/assets/image/home5.png" alt="icon" />
            </div>
            <span>IP形象定制系统</span>
          </div>
          <div class="sidebar-item">
            <div class="sidebar-icon">
              <img src="@/assets/image/home6.png" alt="icon" />
            </div>
            <span>AI数字人交互系统</span>
          </div>
          <div class="sidebar-item">
            <div class="sidebar-icon">
              <img src="@/assets/image/home7.png" alt="icon" />
            </div>
            <span>AIGC视频生成系统</span>
          </div>
        </div>
        <div class="image-gallery">
          <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/homeyewu.png" alt="主营业务" />
        </div>
      </div>
    </div>
    <!-- iBao全栈解决方案区域 -->
    <div class="solution-section">
      <div class="solution-header">
        <img src="@/assets/image/solution.png" alt="iBao全栈解决方案" class="solution-title-image" />
      </div>
      
      <div class="solution-cards">
        <div 
          v-for="solution in solutions" 
          :key="solution.id" 
          class="solution-card"
        >
          <div class="card-image">
            <img :src="solution.image" :alt="solution.title" />
          </div>
          <div class="card-content">
            <span class="card-text">{{ solution.title }}</span>
            <div class="card-arrow" @click="goToSolution(solution.serviceId)">→</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻动态区域 -->
    <div class="news-section">
      <div class="news-header">
        <h2 class="news-title">新闻动态</h2>
      </div>
      
      <div class="news-cards">
        <div 
          v-for="news in newsList" 
          :key="news.id" 
          class="news-card"
        >
          <div class="news-image">
            <img :src="news.image" :alt="news.title" />
            <div class="news-overlay">
              <p class="news-text">{{ news.title }}</p>
              <p class="news-date">{{ news.date }}</p>
              <div class="view-button" @click="goToNewsDetail(news.url)">立即查看</div>
            </div>
          </div>
        </div>
      </div>
      
        <div class="news-more-btn">
          <el-button class="more-button" @click="goToNews">查看更多</el-button>
        </div>
    </div>

    <!-- 合作伙伴区域 -->
    <div class="partners-section">
      <div class="partners-header">
        <h2 class="partners-title">合作伙伴</h2>
        <p class="partners-subtitle">正与众多客户一起创造更多价值</p>
      </div>
      <div class="partners-image">
        <img src="@/assets/image/pattern.png" alt="合作伙伴" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      videoDialogVisible: false,
      solutions: [
        {
          id: 1,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/solution1.png', 
          title: '数字人形象定制服务',
          serviceId: 'service-1'
        },
        {
          id: 2,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/solution2.png',
          title: 'AI屏形机器人',
          serviceId: 'service-4'
        },
        {
          id: 3,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/solution3.png',
          title: '数字人短视频创作系统',
          serviceId: 'service-2'　
        },
        {
          id: 4,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/solution4.png',
          title: 'AIGC视频制作服务',
          serviceId: 'service-6'
        },
        {
          id: 5,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/solution5.png',
          title: '数字人交互系统',
          serviceId: 'service-3'
        },
        {
          id: 6,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/solution6.png',
          title: 'SHINEBO-AI随身秘书',
          serviceId: 'service-5'
        }
      ],
      newsList: [
        {
          id: 20250917,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/news1.png',
          title: '华视闪宝在中国文博会上与四十余家单位达成战略合作，共拓智慧文旅新格局',
          date: '2025-09-17',
          url: 'https://mp.weixin.qq.com/s/2ULhv1qYFDXh3v1sd45fkg',
        },
        {
          id: 2,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/news2.png',
          title: '华视闪宝发布数字人形象定制系统、短视频创作系统、数字人交互系统、AIGC视频四大产品',
          date: '2025-09-10',
          url: 'https://mp.weixin.qq.com/s/chWLFWk_aaosjov_rdu7gw',
        },
        {
          id: 3,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/news3.png',
          title: '华视闪宝数字人开启内测！三大系统构建AI全链路服务！',
          date: '2025-08-01',
          url: 'https://mp.weixin.qq.com/s/fG4PGmb0PTXuBnkepzKBgg',
        },
        {
          id: 4,
          image: 'https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/news4.png',
          title: '华视集团旗下华颜天成与Deepseek达成战略级技术合作。成功将Deepseek-R1大模型接入',
          date: '2025-02-20',
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwNzYxODgxMw==&mid=2651560704&idx=1&sn=37b123155f0c5ee66763786cb22ec269&chksm=81fee3b9ae64b82b1281d853b3c06a0a973801242241a1c0e08765c9ead0d3e349b6ef823670&scene=126&sessionid=1762218950&subscene=91&clicktime=1762219900&enterid=1762219900#rd',
        }
      ]
    }
  },
  methods: {
    watchVideo() {
      this.videoDialogVisible = true;
    },
    handleVideoOpened() {
      // 弹框打开后，确保视频自动播放
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play().catch(err => {
            console.log('视频自动播放失败:', err);
          });
        }
      });
    },
    handleVideoClose() {
      // 关闭弹框时暂停视频
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0; // 重置播放进度
      }
    },
    goToSolution(serviceId) {
      // 跳转到 Solutions 页面，并传递服务项ID
      this.$router.push({
        path: '/solutions',
        query: { serviceId: serviceId }
      });
    },
    goToNews() {
      // 跳转到新闻页面
      this.$router.push('/news');
    },
    goToNewsDetail(url) {
      // 跳转到外部链接
      if (url) {
        window.open(url, '_blank');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 变量定义
$primary-color: #2c3e50;
$secondary-color: #4a90e2;
$accent-color: #357abd;
$background-light: #f0f8ff;
$white: #ffffff;
$text-muted: #6c757d;

// 统一标题样式
%title-style {
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 48px;
  color: #222222;
  padding: 30px 0;
}

.home {
  min-height: 100vh;
  background-color: $background-light;
}

// 顶部英雄区域
.hero-section {
  background: linear-gradient(0deg, #e6f3ff 0%, #93BEEB 100%);

  .hero-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .hero-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;

    .company-name {
      font-size: 3.5rem;
      font-weight: bold;
      color: $primary-color;
      margin-bottom: 15px;
      line-height: 1.2;
    }

    .company-subtitle {
      font-size: 1.3rem;
      color: $primary-color;
      margin-bottom: 30px;
      opacity: 0.8;
    }

    .watch-video-btn {
      background: linear-gradient(135deg, $secondary-color 0%, $accent-color 100%);
      color: $white;
      border: none;
      padding: 15px 30px;
      font-size: 1.1rem;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(74, 144, 226, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(74, 144, 226, 0.4);
      }
    }
  }

  .hero-right {
    flex: 2;
    display: flex;
    justify-content: end;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

// 中间标题区域
.main-headline {
  background: #F6F9FB;
  padding: 40px 0;
  text-align: center;

  h2 {
    @extend %title-style;
    margin: 0;
  }
}

// 底部产品展示区域
.products-section {
  min-height: 600px;

  .products-container {
    // max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    gap: 40px;
  }
}

// 左侧导航栏
.sidebar {
  width: 600px;
  background: #0D1B27;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);

  .sidebar-item {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 20px 15px;
    color: $white;
    transition: all 0.3s ease;
    flex-direction: column;
    flex: 1;

    &.active {
      background: linear-gradient(180deg, #2F80B9 0%, #0560B3 100%);
    }

    &:hover {
      background: linear-gradient(180deg, #2F80B9 0%, #0560B3 100%);
    }

    .sidebar-icon {
      font-size: 1.5rem;
      margin-bottom: 20px;
      margin-top: 10px;
      width: 50px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      
      img {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }

    span {
      font-size: 1rem;
      font-weight: 500;
    }
  }
}

// 右侧产品展示
.products-showcase {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  .product-column {
    background: $white;
    border-radius: 15px;
    padding: 30px 25px;
    box-shadow: 0 8px 25px rgba(0,0,0,0.1);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }

    h3 {
      font-size: 1.4rem;
      color: $primary-color;
      margin-bottom: 10px;
      font-weight: 600;
    }

    .product-subtitle {
      color: $primary-color;
      font-size: 1rem;
      margin-bottom: 20px;
      opacity: 0.8;
    }

    .keywords {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 25px;

      .keyword {
        background: #e8f4fd;
        color: $primary-color;
        padding: 6px 12px;
        border-radius: 15px;
        font-size: 0.85rem;
        font-weight: 500;
      }
    }

    .product-visual {
      text-align: center;

      .visual-placeholder {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        height: 150px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $text-muted;
        font-size: 0.9rem;
        margin-bottom: 15px;
        border: 2px dashed #dee2e6;
      }

      .product-tag {
        color: $primary-color;
        font-size: 0.9rem;
        font-weight: 500;
        margin: 0;
      }
    }
  }
}

// iBao全栈解决方案区域
.solution-section {
  padding-bottom: 80px;
  background: linear-gradient(0deg, #93BEEB 0%, #F0F7FD 100%);
  
  .solution-header {
    text-align: center;
    margin-bottom: 60px;
    
    .solution-title-image {
      max-width: 400px;
      width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }
  
  .solution-cards {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
  
  .solution-card {
    background: $white;
    overflow: hidden;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
    }
    
    .card-image {
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e9ecef;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    
    .card-content {
      background: $white;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      .card-text {
        color: $primary-color;
        font-size: 1.1rem;
        font-weight: 500;
        flex: 1;
      }
      
      .card-arrow {
        color: $secondary-color;
        font-size: 1.5rem;
        font-weight: bold;
        margin-left: 15px;
        transition: transform 0.3s ease;
        cursor: pointer;
      }
    }
    
    &:hover .card-arrow {
      transform: translateX(5px);
    }
  }
}

// 新闻动态区域
.news-section {
  padding: 60px 0;
  background: #F5F7FA;
  
  .news-header {
    text-align: center;
    margin-bottom: 60px;
    
    .news-title {
      @extend %title-style;
      margin: 0;
      position: relative;
      
 
    }
  }
  
  .news-cards {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
  }
  
  .news-card {
    position: relative;
    // aspect-ratio: 16 / 9;
    overflow: hidden;
    transition: transform 0.3s ease;
    
    &:hover {
      transform: translateY(-15px);
    }
    
    .news-image {
      position: relative;
      width: 100%;
      height: 100%;
      
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
      
      .news-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
        color: $white;
        justify-content: center;
        display: flex;
        flex-direction: column;
        height: 100%;

        .news-text {
          font-size: 0.9rem;
          line-height: 1.4;
          margin: 0 0 10px 0;
          color: $white;
          padding: 0 20px;
        }
        
        .news-date {
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.8);
          margin: 0;
          padding: 0 20px;
        }

        .view-button {
          background-color: #ffffff50;
          color: #ffffff;
          padding: 0;
          text-align: center;
          padding: 8px 0;
          font-size: 0.8rem;
          display: none;
          margin-top: 20px;
          cursor: pointer;
        }
      }

      &:hover {
        .view-button {
          display: block;
        }
        .news-overlay {
          justify-content: end;
        }
      }
    }
  }
  
  .news-more-btn {
    text-align: center;
    margin-top: 40px;
    
    .more-button {
      background: transparent !important;
      color: $primary-color !important;
      padding: 12px 30px !important;
      font-size: 1rem !important;
      cursor: pointer !important;
      transition: all 0.3s ease !important;
      
      &:hover {
        background: $white !important;
        color: $primary-color !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
      }
    }
  }
}

// 合作伙伴区域
.partners-section {
  padding: 80px 0;
  background: $white;
  
  .partners-header {
    text-align: center;
    margin-bottom: 60px;
    padding: 0 20px;
    
    .partners-title {
      @extend %title-style;
      position: relative;
    }
    
    .partners-subtitle {
      font-size: 1.2rem;
      color: $text-muted;
      margin: 0;
      font-weight: 400;
    }
  }
  
  .partners-image {
    width: 100%;
    max-width: 1200px;
    margin: auto;
    
    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .products-showcase {
    grid-template-columns: 1fr;
  }
  
  .products-container {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    flex-direction: row;
    justify-content: space-around;

    .sidebar-item {
      flex-direction: column;
      text-align: center;
      padding: 15px 10px;

      span {
        font-size: 0.9rem;
      }
    }
  }
  
  .solution-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .news-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
  }
  
  .company-name {
    font-size: 2.5rem;
  }
  
  .main-headline h2 {
    font-size: 1.8rem;
  }
  
  .products-container {
    padding: 0 15px;
  }
  
  .sidebar {
    padding: 20px 15px;

    .sidebar-item {
      padding: 12px 8px;

      .sidebar-icon {
        font-size: 1.2rem;
      }

      span {
        font-size: 0.8rem;
      }
    }
  }
  
  .solution-section {
    padding: 60px 0;
    
    .solution-header {
      margin-bottom: 40px;
      
      .solution-title-image {
        max-width: 300px;
      }
    }
    
    .solution-cards {
      grid-template-columns: 1fr;
      gap: 20px;
      padding: 0 15px;
    }
    
    .solution-card {
      .card-image {
        height: 150px;
      }
      
      .card-content {
        padding: 15px;
        
        .card-text {
          font-size: 1rem;
        }
        
        .card-arrow {
          font-size: 1.3rem;
        }
      }
    }
  }
  
  .news-section {
    padding: 60px 0;
    
    .news-header {
      margin-bottom: 40px;
      
      .news-title {
        font-size: 28px;
        line-height: 36px;
      }
    }
    
    .news-cards {
      grid-template-columns: 1fr;
      gap: 20px;
      padding: 0 15px;
    }
    
    .news-more-btn {
      margin-top: 30px;
      
      .more-button {
        padding: 10px 25px;
        font-size: 0.9rem;
      }
    }
    
    .partners-section {
      padding: 60px 0 0 0;
      
      .partners-header {
        margin-bottom: 40px;
        padding: 0 15px;
        
        .partners-title {
          font-size: 28px;
          line-height: 36px;
        }
        
        .partners-subtitle {
          font-size: 1rem;
        }
      }
    }
  }
}

// 视频弹框样式（使用深度选择器，因为 el-dialog 不是 scoped）
::v-deep .video-dialog {
  margin-top: 40px !important;
  
  .el-dialog__body {
    padding: 20px;
  }
  
  .video-container {
    width: 100%;
    max-width: 100%;
    
    video {
      width: 100%;
      height: auto;
      border-radius: 8px;
      background: #000;
    }
  }
}

@media (max-width: 768px) {
  ::v-deep .video-dialog {
    width: 95% !important;
    margin: 5vh auto !important;
    
    .el-dialog__body {
      padding: 15px;
    }
  }
}
</style>
